// import WorkatoActivation from '@/components/workato/workato-activation';
// import WorkatoNonadmin from '@/components/workato/workato-nonadmin';
// import WorkatoIntegration from '@/components/workato/workato-integration';
// import Workflows from '@/components/workato/workflows';
import { appCode } from '../../config';


if (process.env.NODE_ENV === 'test') {
  require.ensure = (_, cb) => cb(require);
}

/* eslint-disable global-require */
// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
// const GetStarted = r => require.ensure([], () => r(require('@/components/getStarted/get-started')), 'GetStarted');
// const Partners = r => require.ensure([], () => r(require('@/components/partners/partners')), 'Partners');
// const Widgets = r => require.ensure([], () => r(require('@/components/widgets/widgets')), 'Widgets');
/* eslint-enable global-require */

const Workflows = () => import(/* webpackChunkName: "workflows" */ '@/components/workato/workflows');
const WorkatoActivation = () => import(/* webpackChunkName: "workato-activation" */ '@/components/workato/workato-activation');
const WorkatoNonAdmin = () => import(/* webpackChunkName: "workato-nonadmin" */ '@/components/workato/workato-nonadmin');
const WorkatoIntegration = () => import(/* webpackChunkName: "workato-integration" */ '@/components/workato/workato-integration');

const routes = [
  {
    path: `/${appCode}`,
    redirect: { name: 'get-started' },
  },
  {
    path: `/${appCode}/get-started`,
    name: 'get-started',
    components: {
      [appCode]: () => import(/* webpackChunkName: "get-started" */ '@/components/getStarted/get-started'),
    },
  },
  {
    path: `/${appCode}/partners`,
    name: 'partners',
    components: {
      [appCode]: () => import(/* webpackChunkName: "partners" */ '@/components/partners/partners'),
    },
  },
  {
    path: `/${appCode}/workflows`,
    name: 'workflows',
    components: {
      [appCode]: Workflows,
    },
    // children: [
    //   {
    //     path: 'workato-activation',
    //     name: 'workato-activation',
    //     component: WorkatoActivation,
    //   },
    //   {
    //     path: 'workato-nonadmin',
    //     name: 'workato-nonadmin',
    //     component: WorkatoNonAdmin,
    //   },
    //   {
    //     path: 'workato-integration',
    //     name: 'workato-integration',
    //     component: WorkatoIntegration,
    //   },

    // ],
  },
  {
    path: `/${appCode}/integration/:workatoPath*`,
    name: 'workato-integration',
    components: { [appCode]: WorkatoIntegration },
  },
  {
    path: `/${appCode}/tenant-activation`,
    name: 'workato-activation',
    components: { [appCode]: WorkatoActivation },
  },
  {
    path: `/${appCode}/account-activation`,
    name: 'workato-nonadmin',
    components: { [appCode]: WorkatoNonAdmin },
  },
  {
    path: `/${appCode}/widgets`,
    name: 'widgets',
    components: { 
      [appCode]: () => import(/* webpackChunkName: "widgets" */ '@/components/widgets/widgets'),
    },
  },
  {
    path: `/${appCode}/:catchall*`,
    name: `${appCode}:default`,
    redirect: { name: 'get-started' },
  },
];

export default routes;
